import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { UserResponseData } from "../user"

interface UserData {
  appVersion: string
  browserType: string
  channel: string
  city: string
  country: string
  dialerCode: string
  dobDt?: string
  emailId: string | null
  firstName: string
  ipAddress: string
  isTrmsncndAccepted: boolean
  lastName: string
  macId: string
  mobileno1: string
  password: string
  signinFrom: string
  state: string
  trmsncndAcceptedDate: string
  trmsncndAcceptedVersion: string
  userType: number
  signupFrom?: string
  fromCheckout?: boolean
  propertyMinAgeAtBooking?: boolean
}
export interface SaveUserRequest extends Partial<AxiosRequestConfig> {
  params: {
    user: UserData
  }
}

interface SaveUserResponseData extends ResponseData {
  message?: string
  user: UserResponseData
}

export interface SaveUserResponse extends AxiosResponse {
  data: SaveUserResponseData
}
interface SaveUserWithEmailResponseData extends ResponseData {
  firstName: string
  isEmailVerify: boolean
  message: string
  subject: string
  userId: number
}
export interface SaveUserWithEmailResponse extends AxiosResponse {
  data: SaveUserWithEmailResponseData
}

export function saveUserApi(
  { params }: SaveUserRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params.user,
    method: "post",
    url: "/auth/user",
  }) as Promise<SaveUserResponse>
}

export function signUpUserWithEmailApi(
  { params }: SaveUserRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params.user,
    method: "post",
    url: "/auth/user-with-email",
  }) as Promise<SaveUserWithEmailResponse>
}

export function signUpGuestUserWithEmailApi(
  { params }: SaveUserRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params.user,
    method: "post",
    url: "/auth/guest-checkout-user-with-email",
  }) as Promise<SaveUserWithEmailResponse>
}

export interface MarketingInfoOptInOutRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    isMarketingOptInOut: boolean
    isInformationOptInOut: boolean
  }
}
interface MarketingInfoOptInOutResponseData extends ResponseData {
  data: unknown
}
export interface MarketingInfoOptInOutResponse extends AxiosResponse {
  data: MarketingInfoOptInOutResponseData
}
export function marketingInfoOptInOut(
  { params }: MarketingInfoOptInOutRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "put",
    url: "/user/marketing-info-opt-in-out",
  }) as Promise<MarketingInfoOptInOutResponse>
}
